import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Rooms.css'; // Assurez-vous d'ajouter le CSS pour les styles
import steinwayPiano from './path/to/steinwayPiano.jpg'; // Ajustez le chemin
import uprightPiano from './path/to/uprightPiano.jpg'; // Ajustez le chemin
import Modal from 'react-modal';
import Login from './Login';
import Register from './Register';
import { AuthContext } from '../context/AuthContext';

const RoomList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [redirectUrl, setRedirectUrl] = useState('');

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleReservationClick = (room) => {
    const token = localStorage.getItem('token');
    const bookingUrl = `/booking-calendar?salle=${room}`;

    if (!token) {
      setRedirectUrl(bookingUrl);
      setModalIsOpen(true);
    } else {
      navigate(bookingUrl);
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="rooms-container">
      <h2>Nos Salles de Piano</h2>

      {/* Grande Salle */}
      <section id="grande-salle" className="room-section">
        <h3>Grande Salle</h3>
        <img src={steinwayPiano} alt="Grande salle avec piano Steinway" />
        <p>
          La grande salle est équipée d'un magnifique piano Steinway, offrant une acoustique parfaite pour vos performances de haut niveau. 
          Elle est idéale pour des concerts, des répétitions avec plusieurs musiciens, ou des événements musicaux.
        </p>
        <p>Surface : 35m² | Capacité : 50 personnes</p>

        {/* Actions */}
        <div className="room-actions">
          <button className="reserve-button" onClick={() => handleReservationClick('grande')}>Réserver</button>
        </div>
      </section>

      {/* Petite Salle */}
      <section id="petite-salle" className="room-section">
        <h3>Petite Salle</h3>
        <img src={uprightPiano} alt="Petite salle avec piano droit" />
        <p>
          La petite salle est parfaite pour les répétitions en solo. Elle est équipée d'un piano droit de qualité supérieure pour une pratique quotidienne.
        </p>
        <p>Surface : 15m² | Capacité : 5 personnes</p>

        {/* Actions */}
        <div className="room-actions">
          <button className="reserve-button" onClick={() => handleReservationClick('petite')}>Réserver</button>
        </div>
      </section>

      {/* Modal for login or register */}
	<Modal
	  isOpen={modalIsOpen}
	  onRequestClose={closeModal}
	  contentLabel="Login or Register"
	  className="auth-modal"
	  overlayClassName="modal-overlay"
	  ariaHideApp={false}
	>
	  {isLoginMode ? (
	    <>
	      <Login onSuccess={() => { closeModal(); navigate(redirectUrl); }} />
	    </>
	  ) : (
	    <>
	      <Register onSuccess={() => { closeModal(); navigate(redirectUrl); }} />
	      <p>Déjà un compte ? <button onClick={() => setIsLoginMode(true)} className="switch-button">Se connecter</button></p>
	    </>
	  )}
	</Modal>
    </div>
  );
};

export default RoomList;